import React, { useEffect, useState } from 'react'
import CommonPopup from '../../PopupForm/CommonPopup';
import * as Yup from 'yup';

const Banner = ({title, description, service}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const options = {
        btn_name: "Submit"
    }
    
    const fields = [
        {
            name: 'name',
            label: '',
            placeholder: 'Full Name*',
            validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
            className:'block text-gray-700 w-full py-2 border-b focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'company_name',
            label: '',
            placeholder: 'Company Name',
            className:'block text-gray-700 w-full py-2 border-b focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'phone',
            label: '',
            placeholder: 'Phone Number',
            className:'block text-gray-700 w-full py-2 border-b focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: 'Add Your Company E-mail Address*',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            className:'block text-gray-700 w-full py-2 border-b focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        
        },
        {
            name: 'project_overview',
            label: '',
            placeholder: 'Project Overview',
            type: 'textarea',
            col_row:2,
            className:'block text-gray-700 w-full py-2 border-b focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'project_goal',
            label: '',
            placeholder: 'Project Goal',
            type: 'textarea',
            col_row:2,
            className:'block text-gray-700 w-full py-2 border-b focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'scope_of_work',
            label: '',
            placeholder: 'Scope of Work',
            type: 'textarea',
            col_row:2,
            className:'block text-gray-700 w-full py-2 border-b focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'submission_request',
            label: '',
            placeholder: 'Submission Request',
            type: 'textarea',
            col_row:2,
            className:'block text-gray-700 w-full py-2 border-b focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'submit_date',
            label: '',
            type: 'date',
            className:'block text-gray-700 w-full py-2 border-b focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'file_name',
            label: '',
            type: 'file',
            className:'block text-gray-700 w-full py-2 border-b focus:outline-none focus-visible:border-b border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
    ];
  return (
    <>
        <div id="bannerConsultingList" className='bannerConsultingList'>
            <div className="container">
                <div className="row">
                    <div className="flex justify-center bannerContent sm:justify-end">
                        <div className="bannerHeading">
                            <h1>
                            {title}
                               
                            </h1>
                            <div className="heading-text">
                            {description}
                           </div>
                           <button onClick={openModal} className="w-full px-4 py-2 mt-4 text-white bg-blue-500 rounded hover:bg-blue-600">
                                Request For Proposal
                            </button>
                            <CommonPopup isOpen={isModalOpen} closeModal={closeModal} 
                                service_name={service} 
                                fields={fields}
                                title="Request For Proposal"
                                options={options}
                                page_name="Consulting Services"
                                form_name="rfp-form-consulting-static-page"
                                formTitle="Request For Proposal"
                                style={{minHeight: '400px', overflowY: 'scroll'}}
                                endpoint="/enquiry/request-for-proposal"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}
export default Banner;